import type { DiscountOption } from '@/models/discount-option'
import type { DiscountOptionWeek } from '@/models/discount-option-week'
import { map } from 'nanostores'

export const $discountOptions = map<Record<string, DiscountOption>>()
export const $discountOptionWeeks = map<Record<string, DiscountOptionWeek[]>>()
export const $promises = map<Record<string, Promise<any> | undefined>>()

export const loggables = {
  'discount-option/$discountOptions': $discountOptions,
  'discount-option/$discountOptionWeeks': $discountOptionWeeks,
  // 'discount-option/$promises': $promises,
}
